var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7177 14.8363H1.17084C0.524109 14.8363 0 14.3121 0 13.6654V2.00283C0 1.35619 0.524109 0.83197 1.17084 0.83197H21.0731C21.7195 0.83197 22.244 1.35619 22.244 2.00283V5.06679C22.244 5.71301 21.7195 6.23765 21.0731 6.23765C20.4268 6.23765 19.9023 5.71301 19.9023 5.06679V3.17369H2.3418V12.4946H15.1102C15.3641 12.4946 15.6123 12.5776 15.8136 12.731L19.9023 15.8171V10.0856C19.9023 9.43938 20.4268 8.91474 21.0731 8.91474C21.7195 8.91474 22.244 9.43938 22.244 10.0856V18.1682C22.244 18.6124 21.9911 19.0183 21.5977 19.2163C21.1996 19.4143 20.7219 19.3703 20.366 19.1026L14.7177 14.8363Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.238d33cd78cbe11250cfe1686cb54a11.svg";
export { ForwardRef as ReactComponent };